import { useState } from 'react';
import { MonthlyAnnualSelector, Plugin } from '../partials';
import { useParams } from 'react-router-dom';
import { getPlugins } from "../Api";
import { Helmet, HelmetProvider } from "react-helmet-async";

const PluginList = () => {
    const [monthly, setMonthly] = useState(true);
    const [searchText, setSearchText] = useState("");
    const { lang } = useParams();

    let list = getPlugins();

    const filteredPlugins = list.filter(feature =>
        feature.name.toLowerCase().includes(searchText.toLowerCase()) ||
        feature.description.toLowerCase().includes(searchText.toLowerCase())
    );

    return <>
        <HelmetProvider>
            <Helmet>
                <title>Plugins - Aronium</title>
                <meta name="description" content="Aronium plugins offer an extra functionality" />
            </Helmet>
        </HelmetProvider>

        <section className='max-w-screen-xl mx-auto max-w-screen px-4 pb-12'>
            <div className="text-center my-8">
                <h1 className="text-4xl mb-4">Plugins</h1>
                <p>Extend Aronium beyond built-in functionality</p>
            </div>

            <div className='prose max-w-screen-xl'>
                <p>Aronium is a modular application designed to grow with your business. With a wide range of optional plugins, you can unlock powerful features and customize your point of sale to fit the way you work - <span className='underline underline-offset-4 decoration-green-400 decoration-2'>no unnecessary tools, just what your business needs to thrive</span>.</p>
            </div>

            <div className="max-w-md mx-auto my-8">
                <div className='relative'>
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input type="search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="border border-gray-300 rounded-lg px-4 py-2.5 ps-10 w-full focus:outline-none focus:ring focus:ring-blue-500"
                        placeholder="Search plugins..." />
                </div>
            </div>

            <div>
                <p className='text-center mb-2 text-sm text-gray-500'>Select pricing option for paid plugins</p>
                <MonthlyAnnualSelector monthly={monthly} setMonthly={setMonthly} />
            </div>

            <div className="grid md:grid-cols-3 xl:grid-cols-4 gap-4 xl:px-0">
                {
                    filteredPlugins.map((item, index) => (
                        <Plugin key={index}
                            plugin={item}
                            showMonthlyPrice={monthly}
                            url={`/${lang}/plugins/${item.slug}`} />))
                }
            </div>
        </section>
    </>
}

export default PluginList;